import { ContactinfoRemoteContent } from '@aem/models/ContactinfoRemoteContent';
import { ContactInfoContent } from '@shared/services/content/content-jsons/contact-info-content';
import { SharedContent } from '@shared/services/content/content-jsons/shared-content';

export type PageContent = typeof ContactInfoContent;

export const toPageContent = (remoteContent: ContactinfoRemoteContent): PageContent => {
  return {
    pageTitle: remoteContent.data.minorOpenAccountContactInfoFormContainer.item.heading,
    useOfResidenceMsg:
      remoteContent.data.minorOpenAccountContactInfoFormContainer.item.body.plaintext,
    continueButton: SharedContent.buttons.continueButton,
  };
};
